import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'postal-code'
})
export class PostalCodePipe implements PipeTransform {

  transform(value: string): any {
    if(!value) {
      return '';
    }
    
    if (value[value.length-1] === '-') {
      return value.substr(0, value.length-1);
    }

    if (value.length === 10) {
      let plusFour = value.substr(value.length - 4, 4);
      if (plusFour.indexOf('_') > -1) {
        return value.substr(0, 5);
      }
    }

    return value;
  }

}
